import { useEffect, useState } from 'react';
import { useScrollReveal } from '@/hooks/useScrollReveal';
import { useTranslations } from '@/hooks/useTranslations';
import { supabase } from '@/integrations/supabase/client';

interface PressMention {
  id: string;
  name: string;
  logo_url: string | null;
  article_url: string | null;
}

const PressBanner = () => {
  const { language } = useTranslations();
  const { ref, isVisible } = useScrollReveal({ threshold: 0.2 });
  const [items, setItems] = useState<PressMention[]>([]);

  useEffect(() => {
    supabase
      .from('press_mentions')
      .select('id,name,logo_url,article_url')
      .eq('is_active', true)
      .eq('is_paid', false)
      .order('sort_order')
      .then(({ data }) => setItems((data as PressMention[]) || []));
  }, []);

  if (items.length === 0) return null;

  const label = language === 'en' ? 'Featured in' : 'Erwähnt in';

  return (
    <div ref={ref} className={`w-screen relative left-1/2 -translate-x-1/2 bg-background border-y border-border/50 transition-opacity duration-300 ease-out ${isVisible ? 'opacity-100' : 'opacity-0'}`}>
      <div className="w-full py-6 gap-4 flex flex-col items-center md:py-10">
        <h2 className="text-foreground/70 text-typography-meta tracking-widest uppercase text-center px-5">{label}</h2>
        <ul className="flex flex-wrap items-center justify-center gap-x-10 gap-y-4 px-5">
          {items.map((m) => {
            const content = m.logo_url ? (
              <img src={m.logo_url} alt={m.name} loading="lazy" className="h-6 md:h-8 w-auto object-contain grayscale opacity-80" />
            ) : (
              <span className="text-foreground/80 text-sm font-medium">{m.name}</span>
            );
            return (
              <li key={m.id}>
                {m.article_url ? (
                  <a href={m.article_url} target="_blank" rel="noopener noreferrer" aria-label={`${m.name} (${language === 'en' ? 'opens in new tab' : 'öffnet in neuem Tab'})`} className="block rounded focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring">
                    {content}
                  </a>
                ) : content}
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};
export default PressBanner;
